import cmdLogEvent from '../tccl/methods/cmdLogEvent';
import cmdLogPerf from '../tccl/methods/cmdLogPerf';

// Methods used for the traffic data layer process are published through here
export { cmdLogEvent, cmdLogPerf };
